<template>
    <el-tabs type="border-card" @tab-click="SetData" v-model="Act">
      <el-tab-pane :label="item.system_name" :name="item.system_code" v-for="item in SystemList" :key="item.system_code">
            <AdminForm v-if="Act == item.system_code" :ApiType='item.system_code' :Child="item.child"></AdminForm>
      </el-tab-pane>
    </el-tabs>
</template>

<script>
    export default {
        data() {
            return {
                Act:"",
                SystemList:"",
            };
        },
        mounted() {
            this.SystemList = JSON.parse(this.$Tools.localData("ThisMenu"));
            this.Act = this.SystemList[0].system_code || "";
            this.$Tools.localData("ApiType",this.Act);
        },
        methods: {
            SetData(tab) {
                this.Act = tab.name;
                this.$Tools.localData("ApiType",this.Act);
            },
        },
    }
</script>

<style>
</style>